// Request Cancel Service
// An attendee takes back their own request through a callable that checks votes and rankings live (ITER-202)

import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import { REQUEST_CANCEL_BLOCKS } from '../utils/requestCancel';
import type { RequestCancelBlock } from '../utils/requestCancel';

export async function cancelOwnRequest(requestId: string): Promise<void> {
  const callable = httpsCallable<{ requestId: string }, { ok: true }>(functions, 'cancelOwnRequest');
  await callable({ requestId });
}

export function cancelRefusalReason(error: unknown): RequestCancelBlock | null {
  if (typeof error !== 'object' || error === null) return null;
  const { details } = error as { details?: unknown };
  const reason = (details as { reason?: unknown } | null | undefined)?.reason;
  return REQUEST_CANCEL_BLOCKS.find((block) => block === reason) ?? null;
}
